<template>
    <div class="page-content">
        <h1 v-if="returnDetails">{{ returnDetails.name }}</h1>
        <div v-else class="name-skeleton"></div>
        <input
            type="hidden"
            name="return_id"
            :value="returnDetails ? returnDetails.id : null"
        />
        <b-card footer-class="p-0">
            <return-edit v-if="isEditMode" ref="returnEditPart" />
            <return-display v-else />

            <template v-slot:footer no-body>
                <b-tabs
                    card
                    lazy
                    class="list tab-table-responsive"
                    ref="btabs"
                    v-model="activeTabIndex"
                    v-if="returnDetails"
                >
                    <b-tab title-link-class="p-0">
                        <template v-slot:title>
                            <b-nav-item-dropdown
                                no-flip
                                v-if="!returnDetails.status"
                            >
                                <template slot="button-content">
                                    <i class="cus-page-white-text"></i>
                                    Items
                                </template>
                                <div>
                                    <b-dropdown-item
                                        @click="refreshReturnItems"
                                    >
                                        <i class="cus-page-white-text"></i>
                                        View Items
                                    </b-dropdown-item>
                                </div>

                                <li
                                    v-if="
                                        _hasAccess('billing.return.create') &&
                                        !returnDetails.status &&
                                        isactiveClient
                                    "
                                    class="dropdown-divider"
                                ></li>

                                <b-dropdown-item
                                    v-if="
                                        _hasAccess('billing.return.create') &&
                                        !returnDetails.status &&
                                        isactiveClient
                                    "
                                    @click="openNewItem()"
                                >
                                    <i class="cus-add"></i>
                                    New Item
                                </b-dropdown-item>
                            </b-nav-item-dropdown>
                            <b-nav-item v-else @click="refreshReturnItems">
                                <i class="cus-page-white-text"></i>
                                Items
                            </b-nav-item>
                        </template>
                        <b-card-text>
                            <return-items
                                v-if="returnDetails"
                                :key="itemsKey"
                            />
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </template>
        </b-card>
        <modal-item
            v-if="returnDetails"
            ref="modal-item"
            modal-ref="modal-item"
            :return-details="returnDetails"
            @reload="refreshReturnItems"
        />
    </div>
</template>
<script>
/**
 * @name ReturnDetailPage
 * @description Details page of selected Return
 * @see apps/application/views/staff/billing/return/return/sub/navbar.php
 */

import ReturnDisplay from "@/components/return-details/details-display";
import ReturnEdit from "@/components/return-details/details-edit";
import ReturnItems from "@/components/return-items/return-items-list";
import ModalItem from "@/components/return-details/modal-item";
import RELATIONS from "@/constants/relations.js";

export default {
    components: {
        ReturnDisplay,
        ReturnEdit,
        ReturnItems,
        ModalItem
    },
    data() {
        return {
            isRendered: false,
            activeTabIndex: 0,
            itemsKey: 0
        };
    },
    computed: {
        routeParam() {
            return this.$route.params.id;
        },
        returnDetails() {
            return this.$store.getters["returnDetails/returnDetails"];
        },
        isEditMode() {
            return this.$store.getters["returnDetails/isEditMode"];
        },
        theReturn() {
            return this.$store.getters["returnDetails/returnDetails"];
        },
        isactiveClient() {
            let client = this.theReturn.client
                ? this.theReturn.client.single_business_actor
                : null;

            if (client) {
                return (
                    client.isactive &&
                    client.relation_type == RELATIONS.BUSINESS_ACTOR.CLIENT
                );
            }

            return false;
        }
    },
    watch: {
        routeParam() {
            this.componentKey++;
            this.getDetails();
        }
    },
    destroyed() {
        // empty (nullify) the Return details in the Store
        // to prevent the page from fetching list items that are present in previous records (if any)
        this.$store.commit("returnDetails/clearReturnDetails");
    },
    mounted() {
        let self = this;
        this.getDetails();
        this.$root.$on("refresh-return-page", () => {
            self.getDetails();
        });
    },
    methods: {
        async getDetails() {
            await this._getSetting(); // wait for render hasAccess
            this.isRendered = true;
            this.activeTabIndex = 0;

            var self = this;
            var encodedId = this.routeParam;

            if (encodedId) {
                this.$store
                    .dispatch("returnDetails/getReturnDetails", encodedId)
                    .then(hasData => {
                        if (hasData) {
                            setTimeout(() => {
                                self.storeAudit();
                            }, 1000);
                            self.generatePageTitle();
                        } else {
                            this.$router.push({ name: "billing_dashboard" });
                        }
                    });
            } else {
                this.$router.push({ name: "billing_dashboard" });
            }
        },
        generatePageTitle() {
            this.dynamicPageTitle(
                _.isEmpty(this.returnDetails)
                    ? "Return Page"
                    : this.returnDetails.name
            );
        },
        openModal() {},
        openNewItem() {
            this.$refs["modal-item"].open();
        },
        async storeAudit() {
            const returnId = _.clone(this.returnDetails.id);
            const fullPath = _.clone(this.$router.currentRoute.fullPath);

            if (!returnId) {
                return;
            }

            this._getSetting().then(() => {
                this._saveAudit({
                    action: "view",
                    path: "/billing/returns/view." + returnId,
                    reference_id: returnId,
                    fullPath
                });
            });
        },
        saveEdit() {
            this.$refs.returnEditPart.save();
        },
        refreshReturnItems() {
            this.getDetails(); // refresh amount
            this.itemsKey++;
        }
    }
};
</script>
